export default "__VITE_ASSET__ijkRq4tE__"